<div class="header">
  <div>
    <div class="headerLogo">
      <img
        src="assets/icons/lucide_menu.png"
        alt="logo"
        height="21px"
        width="23px"
        (click)="expandedBtn()"
      />
      <img loading="lazy" src="assets/icons/headerImg.png" alt="" height="40px" />
    </div>
  </div>
  <div class="d-flex" >
    <div class="headerLogo">
      <input type="text" class="searchInput" placeholder="Search" />
      <i class="fa fa-search searchIcon" aria-hidden="true"></i>
    </div>
    <div class="d-flex">
      <div>
        <span class="headerTime">10:10 AM</span>
      </div>
      <img
        class="flagIcon"
        src="assets/icons/baseline-flag.png"
        alt=""
      />
      <!-- <span>
      <span>0</span>
      </span> -->
      <span> </span>
    </div>
  </div>

  <div class="d-flex">
    <span class="lastLogin"> Last Login in {{currentDate  | date:'dd-MMM-yy, hh:mm a'}} </span>
    <div class="btn-group ms-2">
      <span
        class="Icon relative me-3 p-0"
        data-bs-toggle="dropdown"
        data-bs-display="static"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <img
          src="assets/images/theme.png"
          alt="theme.png"
          width="30px"
        />
      </span>
      <div class="dropdown-menu dropdown-menu-end p-2 pb-3">
        <!-- <div class="flex items-center gap-3">
          <label class="switch">
            <input
              id="input"
              type="checkbox"
              checked="darkTheme"
              [(ngModel)]="theme"
              (change)="themeChange($event)"
            />
            <div class="slider round">
              <div class="sun-moon">
                <svg id="moon-dot-1" class="moon-dot" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="50"></circle>
                </svg>
                <svg id="moon-dot-2" class="moon-dot" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="50"></circle>
                </svg>
                <svg id="moon-dot-3" class="moon-dot" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="50"></circle>
                </svg>
                <svg id="light-ray-1" class="light-ray" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="50"></circle>
                </svg>
                <svg id="light-ray-2" class="light-ray" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="50"></circle>
                </svg>
                <svg id="light-ray-3" class="light-ray" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="50"></circle>
                </svg>
                <svg id="cloud-1" class="cloud-dark" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="50"></circle>
                </svg>
                <svg id="cloud-2" class="cloud-dark" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="50"></circle>
                </svg>
                <svg id="cloud-3" class="cloud-dark" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="50"></circle>
                </svg>
                <svg id="cloud-4" class="cloud-light" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="50"></circle>
                </svg>
                <svg id="cloud-5" class="cloud-light" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="50"></circle>
                </svg>
                <svg id="cloud-6" class="cloud-light" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="50"></circle>
                </svg>
              </div>
              <div class="stars">
                <svg id="star-1" class="star" viewBox="0 0 20 20">
                  <path
                    d="M 0 10 C 10 10,10 10 ,0 10 C 10 10 , 10 10 , 10 20 C 10 10 , 10 10 , 20 10 C 10 10 , 10 10 , 10 0 C 10 10,10 10 ,0 10 Z"
                  ></path>
                </svg>
                <svg id="star-2" class="star" viewBox="0 0 20 20">
                  <path
                    d="M 0 10 C 10 10,10 10 ,0 10 C 10 10 , 10 10 , 10 20 C 10 10 , 10 10 , 20 10 C 10 10 , 10 10 , 10 0 C 10 10,10 10 ,0 10 Z"
                  ></path>
                </svg>
                <svg id="star-3" class="star" viewBox="0 0 20 20">
                  <path
                    d="M 0 10 C 10 10,10 10 ,0 10 C 10 10 , 10 10 , 10 20 C 10 10 , 10 10 , 20 10 C 10 10 , 10 10 , 10 0 C 10 10,10 10 ,0 10 Z"
                  ></path>
                </svg>
                <svg id="star-4" class="star" viewBox="0 0 20 20">
                  <path
                    d="M 0 10 C 10 10,10 10 ,0 10 C 10 10 , 10 10 , 10 20 C 10 10 , 10 10 , 20 10 C 10 10 , 10 10 , 10 0 C 10 10,10 10 ,0 10 Z"
                  ></path>
                </svg>
              </div>
            </div>
          </label>
          <span class="bigInputText" for="input" *ngIf="theme">Dark</span>
          <span class="bigInputText" for="input" *ngIf="!theme">Light</span>
        </div> -->
        <div class="color-theme my-2">
          <div class="flex items-center gap-3">
            <input
              type="color"
              [(ngModel)]="primaryColor"
              (input)="updateColors('--color-primary', primaryColor)"
            />
            <label>Primary Color</label>
          </div>
          <div class="flex items-center gap-3 my-2">
            <input
              type="color"
              [(ngModel)]="secondaryColor"
              (input)="updateColors('--color-secondary', secondaryColor)"
            />
            <label>Secondary Color</label>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-group">
      <span
        (click)="toggleDropdown()"
        class="Icon relative me-3 p-0"
        data-bs-toggle="dropdown"
        data-bs-display="static"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <img
          src="assets/icons/Frame 185985.png"
          style="
            border-radius: 50%;
            background-repeat: no-repeat;
            background-size: cover;
            width: 30px;
          "
          alt=""
        />
      </span>
      <span class="loginUser">{{userName}} </span>
      <span class="loginUserIcon"
        ><img loading="lazy" src="assets/icons/Vector-down.png" alt=""
      /></span>
      <div
        class="dropdown-menu dropdown-menu-end p-2 pb-3"
        [ngClass]="{ show: isDropdownOpen }"
        (click)="onDropdownClick($event)"
        #dropdownMenu
      >
        <div class="flex justify-end">
          <span class="close_btn" (click)="closeDropdown()">&times;</span>
        </div>
        <div class="flex justify-center">
          <div class="profile_Img relative">
            <img loading="lazy" src="assets/icons/Frame 185985.png" width="30px" alt="" />
          </div>
        </div>
        <div class="flex justify-center m-2">
          <span class="profile_text">{{userName}}</span>
        </div>

        <div class="flex justify-center mt-1">
          <button class="logout_btn" (click)="logout()">Logout</button>
        </div>
      </div>
    </div>
  </div>
</div>
